// REACT IMPORTS
import { useCallback, useState } from "react";

// COMPONENT IMPORTS
import { getApiErrorMessage } from "utils/apiError";

/**
 * The message for a server call that went wrong, for a screen to show in a
 * ServerErrorAlert. `showError` takes the error (or `success: false` reply)
 * and the screen's default text; the message is the server's reason when it
 * has one, else the default.
 */
export const useServerError = () => {
  const [serverError, setServerError] = useState<string | null>(null);

  const showError = useCallback((error: any, fallback: string) => {
    setServerError(getApiErrorMessage(error, fallback));
  }, []);

  const clearError = useCallback(() => setServerError(null), []);

  return { serverError, showError, clearError };
};

export default useServerError;
